import request from '../utils/request.js'

/** 站点接口 */

/**
 * 全部分站申请资料
 * @param params
 * @returns {AxiosPromise}
 */
export function applyDatas(params) {
    return request({
        url: '/api/station_apply',
        method: 'get',
        params: params
    })
}

/**
 * 申请资料详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getApplyData(stationApplyId) {
    return request({
        url: `​/api​/station_apply​/${stationApplyId}`,
        method: 'get'
    })
}

/**
 * 拒绝分站申请
 * @param params
 * @returns {AxiosPromise}
 */
export function rejectSite(params) {
    return request({
        url: '/api/station_apply/reject',
        method: 'post',
        data: params
    })
}

/**
 * 审核通过分站申请
 * @param params
 * @returns {AxiosPromise}
 */
export function resolveSite(params) {
    return request({
        url: '/api/station_apply/resolve',
        method: 'post',
        data: params
    })
}


/**
 * 撤销分站申请
 * @param params
 * @returns {AxiosPromise}
 */
export function undo_station_apply(params) {
    return request({
        url: '/api/station_apply/undo',
        method: 'post',
        data: params
    })
}


/**
 * 全部分站
 * @param params
 * @returns {AxiosPromise}
 */
export function allStation(params) {
    return request({
        url: '/api/station',
        method: 'get',
        params: params
    })
}

/**
 * 批量获取分站详情
 * @param params
 * @returns {AxiosPromise}
 */
 export function StationMget(params) {
    return request({
        url: '/api/station/mget',
        method: 'get',
        params: params
    })
}
/**
 * 保存分站
 * @param params
 * @returns {AxiosPromise}
 */
export function saveStation(params) {
    return request({
        url: '/api/station',
        method: 'post',
        data: params
    })
}

/**
 * 分站详情
 * @param params
 * @returns {AxiosPromise}
 */
export function stationDetail(stationId) {
    return request({
        url: `/api/station/${stationId}`,
        method: 'get'
    })
}


/**
 * 保存等级
 * @param params
 * @returns {AxiosPromise}
 */
export function saveRate(params) {
    return request({
        url: '/api/station/save_rate',
        method: 'post',
        data: params
    })
}


/**

 * @param params
 * @returns {AxiosPromise}
 */
export function stationDisable(stationId) {
    return request({
        url: `/api/station/disable/${stationId}`,
        method: 'get'
    })
}
/**

 * @param params
 * @returns {AxiosPromise}
 */
export function stationEnable(stationId) {
    return request({
        url: `/api/station/enable/${stationId}`,
        method: 'get'
    })
}


/**
 * 分站提现
 * @param params
 * @returns {AxiosPromise}
 */
export function station_withdraw(params) {
    return request({
        url: '/api/station_withdraw',
        method: 'post',
        data: params
    })
}


export function set_state(params) {
    return request({
        url: '/api/station_withdraw/state',
        method: 'post',
        data: params
    })
}


export function see_state(params) {
    return request({
        url: '/api/station_withdraw/state',
        method: 'get',
    })
}

export function statistic(params) {
    return request({
        url: '/api/station/statistic',
        method: 'get',
    })
}

export function saveDevelop(params) {
    return request({
        url: '/api/station/station_develop',
        method: 'post',
        data: params
    })
}

export function getDevelop(stationId) {
    return request({
        url: `/api/station/station_develop/${stationId}`,
        method: 'get',
    })
}

// 生成二维码短链
export function generate_url(params) {
    return request({
        url: '/api/wechat/generate_url',
        method: 'post',
        data: params
    })
}
// 批量保存分站本地生活配置
export function localcaterBatchSetting(params) {
    return request({
        url: '/api/station/localcater_batch_setting',
        method: 'post',
        data: params
    })
}
// 同步推广员
export function promoterSync(params) {
    return request({
        url: '/api/promoter/sync',
        method: 'post',
        data: params
    })
}
// 保存分销达人
export function postStationFinder(params) {
    return request({
        url: '/api/station_finder',
        method: 'post',
        data: params
    })
}
// 解绑分销达人
export function postStationFinderDel(params) {
    return request({
        url: '/api/station_finder/del',
        method: 'post',
        data: params
    })
}
// 绑定分站默认推客
export function postBindPromoterSharer(params) {
    return request({
        url: '/api/station/bind_promoter_sharer',
        method: 'post',
        data: params
    })
}
// 解绑分站默认推客
export function postBindPromoterSharerId(stationId) {
    return request({
        url: `/api/station/unbind_promoter_sharer/${stationId}`,
        method: 'post',
    })
}
// 提现配置
export function getMerchantWithdraw(stationId) {
    return request({
        url: `/api/merchant_withdraw/${stationId}`,
        method: 'get',
    })
}
// 保存提现配置
export function postMerchantWithdraw(params) {
    return request({
        url: `/api/merchant_withdraw`,
        method: 'post',
         data: params
    })
}


// 保存分站排除京东自营商品
export function postStationExcludeGoods(params) {
    return request({
        url: `/api/station_exclude_goods`,
        method: 'post',
         data: params
    })
}
// 分站排除京东自营商品详情
export function getStationExcludeGoodsId(params) {
    return request({
        url: `/api/station_exclude_goods`,
        method: 'get',
        params:params,
    })
}


// 保存快速出票站点ID列表
export function fast_take_station_ids(params) {
    return request({
        url: `/api/configure/fast_take_station_ids`,
        method: 'post',
         data: params
    })
}
// 获取快速出票站点ID列表
export function get_fast_take_station_ids(params) {
    return request({
        url: `/api/configure/fast_take_station_ids`,
        method: 'get',
        params:params,
    })
}

//保存分站积分配置
export function postStationCoinConfigStation(params) {
    return request({
        url: '/api/station_coin_config/station',
        method: 'post',
        data:params
    })
}